import getTrainingAuthSelector from 'modules/training/modules/app-auth/selectors/get'
import { TRAINING_AUTH_KEY } from 'modules/training/modules/app-auth/constants'

const isSignUpTrainingAuthSelect = getTrainingAuthSelector(TRAINING_AUTH_KEY.IS_SIGN_UP)

export default isSignUpTrainingAuthSelect
